import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["dir"]
const _hoisted_2 = { class: "sticky top-0 z-50 bg-[#07090b]/85 backdrop-blur-md border-b border-white/10" }
const _hoisted_3 = { class: "border-b border-white/5 bg-[#030506]/60 py-2 text-[11px] md:text-xs" }
const _hoisted_4 = { class: "mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6" }
const _hoisted_5 = { class: "flex items-center gap-4" }
const _hoisted_6 = { class: "flex items-center gap-1.5 opacity-80" }
const _hoisted_7 = { class: "flex items-center gap-6" }
const _hoisted_8 = { class: "flex items-center gap-1.5 opacity-80" }
const _hoisted_9 = { class: "mx-auto flex max-w-7xl items-center justify-between px-4 py-3.5 md:px-6" }
const _hoisted_10 = { class: "flex items-center gap-3" }
const _hoisted_11 = { class: "bg-white rounded-xl p-2 shadow-lg flex items-center justify-center" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "hidden lg:flex items-center gap-8 text-sm font-medium tracking-wide" }
const _hoisted_14 = {
  href: "#services",
  class: "hover:text-amber-400 transition"
}
const _hoisted_15 = {
  href: "#services",
  class: "hover:text-amber-400 transition"
}
const _hoisted_16 = {
  href: "#destinations",
  class: "hover:text-amber-400 transition"
}
const _hoisted_17 = {
  href: "#family",
  class: "hover:text-amber-400 transition"
}
const _hoisted_18 = {
  href: "#family",
  class: "hover:text-amber-400 transition"
}
const _hoisted_19 = {
  href: "#footer",
  class: "hover:text-amber-400 transition"
}
const _hoisted_20 = { class: "mx-auto max-w-7xl w-full px-4 md:px-6 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center" }
const _hoisted_21 = { class: "lg:col-span-7 flex flex-col justify-center text-start" }
const _hoisted_22 = { class: "mb-4 self-start inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-semibold text-amber-400 ring-1 ring-white/15" }
const _hoisted_23 = { class: "leading-[1.1] font-extrabold tracking-tight" }
const _hoisted_24 = { class: "block text-4xl md:text-6xl text-white" }
const _hoisted_25 = { class: "block text-5xl md:text-7xl text-amber-400 mt-1" }
const _hoisted_26 = { class: "block text-4xl md:text-6xl text-white mt-1" }
const _hoisted_27 = { class: "mt-6 max-w-xl leading-relaxed text-zinc-300" }
const _hoisted_28 = { class: "text-base md:text-lg font-bold text-white" }
const _hoisted_29 = { class: "mt-2 text-sm md:text-base font-normal opacity-85" }
const _hoisted_30 = { class: "mt-8 flex flex-wrap gap-4" }
const _hoisted_31 = ["href"]
const _hoisted_32 = { class: "mt-10 grid grid-cols-2 sm:grid-cols-3 gap-4 border-t border-white/10 pt-8" }
const _hoisted_33 = { class: "flex items-center gap-2.5" }
const _hoisted_34 = { class: "text-xs font-medium text-zinc-300" }
const _hoisted_35 = { class: "flex items-center gap-2.5" }
const _hoisted_36 = { class: "text-xs font-medium text-zinc-300" }
const _hoisted_37 = { class: "flex items-center gap-2.5" }
const _hoisted_38 = { class: "text-xs font-medium text-zinc-300" }
const _hoisted_39 = { class: "flex items-center gap-2.5" }
const _hoisted_40 = { class: "text-xs font-medium text-zinc-300" }
const _hoisted_41 = { class: "flex items-center gap-2.5" }
const _hoisted_42 = { class: "text-xs font-medium text-zinc-300" }
const _hoisted_43 = { class: "flex items-center gap-2.5" }
const _hoisted_44 = { class: "text-xs font-medium text-zinc-300" }
const _hoisted_45 = {
  id: "quote-form-section",
  class: "lg:col-span-5 w-full"
}
const _hoisted_46 = { class: "lead-card" }
const _hoisted_47 = { class: "text-xl md:text-2xl font-bold tracking-tight text-white" }
const _hoisted_48 = { class: "mt-1 text-xs text-zinc-400" }
const _hoisted_49 = { class: "mb-1 block text-[11px] font-semibold text-zinc-400 uppercase tracking-wider" }
const _hoisted_50 = {
  value: "",
  disabled: ""
}
const _hoisted_51 = { value: "Airport Transfer" }
const _hoisted_52 = { value: "Chauffeur Service" }
const _hoisted_53 = { value: "Car Rental" }
const _hoisted_54 = { value: "Meet & Greet" }
const _hoisted_55 = { value: "Bus" }
const _hoisted_56 = { class: "field-reset min-w-0" }
const _hoisted_57 = { class: "field-reset min-w-0" }
const _hoisted_58 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_59 = { class: "field-reset" }
const _hoisted_60 = { class: "field-reset" }
const _hoisted_61 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_62 = { class: "mb-1 block text-[11px] font-semibold text-zinc-400 uppercase tracking-wider" }
const _hoisted_63 = {
  value: "",
  disabled: ""
}
const _hoisted_64 = { value: "1" }
const _hoisted_65 = { value: "2" }
const _hoisted_66 = { value: "3" }
const _hoisted_67 = { value: "4" }
const _hoisted_68 = { value: "5" }
const _hoisted_69 = { value: "6" }
const _hoisted_70 = { value: "7" }
const _hoisted_71 = { class: "mb-1 block text-[11px] font-semibold text-zinc-400 uppercase tracking-wider" }
const _hoisted_72 = ["placeholder"]
const _hoisted_73 = { class: "mb-1 block text-[11px] font-semibold text-zinc-400 uppercase tracking-wider" }
const _hoisted_74 = { class: "mb-1 block text-[11px] font-semibold text-zinc-400 uppercase tracking-wider" }
const _hoisted_75 = ["placeholder"]
const _hoisted_76 = { class: "mt-2" }
const _hoisted_77 = ["disabled"]
const _hoisted_78 = { class: "mt-3 flex items-center justify-center gap-4 text-[10px] text-zinc-400 uppercase tracking-wider" }
const _hoisted_79 = { class: "flex items-center gap-1" }
const _hoisted_80 = { class: "flex items-center gap-1" }
const _hoisted_81 = {
  id: "services",
  class: "py-20 bg-[#0b0e11] border-y border-white/5"
}
const _hoisted_82 = { class: "mx-auto max-w-7xl px-4 md:px-6" }
const _hoisted_83 = { class: "text-center mb-16" }
const _hoisted_84 = { class: "text-xs font-bold text-amber-500 uppercase tracking-widest" }
const _hoisted_85 = { class: "mt-2 text-3xl md:text-4xl font-extrabold text-white" }
const _hoisted_86 = { class: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6" }
const _hoisted_87 = { class: "mb-4 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-amber-500/10 text-amber-400 group-hover:bg-amber-500 group-hover:text-[#07090b] transition-all duration-300 p-2.5" }
const _hoisted_88 = {
  key: 0,
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1.5"
}
const _hoisted_89 = {
  key: 1,
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1.5"
}
const _hoisted_90 = {
  key: 2,
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1.5"
}
const _hoisted_91 = {
  key: 3,
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1.5"
}
const _hoisted_92 = {
  key: 4,
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1.5"
}
const _hoisted_93 = { class: "text-lg font-bold text-white mb-2 group-hover:text-amber-400 transition-colors" }
const _hoisted_94 = { class: "text-sm text-zinc-400 leading-relaxed" }
const _hoisted_95 = {
  id: "destinations",
  class: "py-20 bg-[#07090b]"
}
const _hoisted_96 = { class: "mx-auto max-w-7xl px-4 md:px-6" }
const _hoisted_97 = { class: "text-center mb-16" }
const _hoisted_98 = { class: "text-xs font-bold text-amber-500 uppercase tracking-widest" }
const _hoisted_99 = { class: "mt-2 text-3xl md:text-5xl font-extrabold text-white" }
const _hoisted_100 = { class: "text-amber-400 italic" }
const _hoisted_101 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-7 gap-4" }
const _hoisted_102 = ["onClick"]
const _hoisted_103 = { class: "relative h-64 overflow-hidden" }
const _hoisted_104 = ["src", "alt"]
const _hoisted_105 = { class: "absolute bottom-4 left-4 right-4 text-start" }
const _hoisted_106 = { class: "text-lg font-bold text-white tracking-wide" }
const _hoisted_107 = { class: "mt-1.5 inline-flex items-center text-[10px] font-bold text-amber-400 uppercase tracking-wider group-hover:text-white transition-colors" }
const _hoisted_108 = { class: "mt-12 text-center" }
const _hoisted_109 = {
  id: "family",
  class: "py-16 bg-[#07090b]"
}
const _hoisted_110 = { class: "mx-auto max-w-7xl px-4 md:px-6" }
const _hoisted_111 = { class: "bg-white rounded-[32px] p-6 md:p-8 shadow-2xl border border-zinc-100 text-zinc-900 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center" }
const _hoisted_112 = { class: "lg:col-span-3 rounded-2xl overflow-hidden shadow-md" }
const _hoisted_113 = ["src"]
const _hoisted_114 = { class: "lg:col-span-5 text-start flex flex-col justify-center" }
const _hoisted_115 = { class: "text-[10px] md:text-xs font-extrabold text-zinc-800 uppercase tracking-widest" }
const _hoisted_116 = { class: "mt-2 text-2xl md:text-3xl font-extrabold text-zinc-900 leading-tight" }
const _hoisted_117 = { class: "text-amber-500" }
const _hoisted_118 = { class: "mt-6 flex items-center justify-between gap-1.5 overflow-x-auto py-1 select-none" }
const _hoisted_119 = { class: "flex flex-col items-center justify-center p-2 bg-white border border-zinc-200 rounded-xl w-[78px] h-[82px] shadow-sm flex-shrink-0" }
const _hoisted_120 = ["innerHTML"]
const _hoisted_121 = { class: "flex flex-col items-center justify-center p-2 bg-white border border-zinc-200 rounded-xl w-[78px] h-[82px] shadow-sm flex-shrink-0" }
const _hoisted_122 = ["innerHTML"]
const _hoisted_123 = { class: "flex flex-col items-center justify-center p-2 bg-white border border-zinc-200 rounded-xl w-[78px] h-[82px] shadow-sm flex-shrink-0" }
const _hoisted_124 = ["innerHTML"]
const _hoisted_125 = { class: "flex flex-col items-center justify-center p-2 bg-white border border-zinc-200 rounded-xl w-[78px] h-[82px] shadow-sm flex-shrink-0" }
const _hoisted_126 = ["innerHTML"]
const _hoisted_127 = { class: "flex flex-col items-center justify-center p-2 bg-white border border-zinc-200 rounded-xl w-[78px] h-[82px] shadow-sm flex-shrink-0" }
const _hoisted_128 = ["innerHTML"]
const _hoisted_129 = { class: "mt-6 text-zinc-600 text-xs md:text-sm leading-relaxed" }
const _hoisted_130 = { class: "mt-6" }
const _hoisted_131 = { class: "lg:col-span-4 flex items-center justify-center" }
const _hoisted_132 = ["src"]
const _hoisted_133 = { class: "py-20 bg-[#07090b]" }
const _hoisted_134 = { class: "mx-auto max-w-7xl px-4 md:px-6" }
const _hoisted_135 = { class: "text-center mb-16" }
const _hoisted_136 = { class: "text-xs font-bold text-amber-500 uppercase tracking-widest" }
const _hoisted_137 = { class: "mt-2 text-3xl md:text-4xl font-extrabold text-white" }
const _hoisted_138 = { class: "grid grid-cols-1 md:grid-cols-3 gap-8" }
const _hoisted_139 = { class: "text-sm md:text-base text-zinc-300 italic leading-relaxed relative z-10" }
const _hoisted_140 = { class: "mt-6 border-t border-white/5 pt-4" }
const _hoisted_141 = { class: "font-bold text-white" }
const _hoisted_142 = { class: "text-xs text-amber-500/80 font-semibold mt-0.5" }
const _hoisted_143 = { class: "mx-auto max-w-4xl px-4 text-center" }
const _hoisted_144 = { class: "text-3xl md:text-5xl font-extrabold leading-tight text-white" }
const _hoisted_145 = { class: "text-amber-400" }
const _hoisted_146 = { class: "mx-auto mt-4 max-w-xl text-sm md:text-base text-zinc-300 leading-relaxed" }
const _hoisted_147 = { class: "mt-8 flex flex-wrap gap-4 justify-center" }
const _hoisted_148 = ["href"]
const _hoisted_149 = { class: "mt-16 grid grid-cols-2 md:grid-cols-6 gap-4 border-t border-white/10 pt-10 text-center" }
const _hoisted_150 = { class: "text-[10px] text-zinc-400 mt-1 uppercase font-medium" }
const _hoisted_151 = { class: "text-[10px] text-zinc-400 mt-1 uppercase font-medium" }
const _hoisted_152 = { class: "text-[10px] text-zinc-400 mt-1 uppercase font-medium" }
const _hoisted_153 = { class: "text-[10px] text-zinc-400 mt-1 uppercase font-medium" }
const _hoisted_154 = { class: "text-[10px] text-zinc-400 mt-1 uppercase font-medium" }
const _hoisted_155 = { class: "text-xl md:text-2xl font-bold text-amber-400" }
const _hoisted_156 = { class: "text-[10px] text-zinc-400 mt-1 uppercase font-medium" }
const _hoisted_157 = {
  id: "footer",
  class: "bg-[#030506] border-t border-white/10 pt-16 pb-8 text-start"
}
const _hoisted_158 = { class: "mx-auto max-w-7xl px-4 md:px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10" }
const _hoisted_159 = { class: "inline-flex bg-white rounded-xl p-1.5 shadow-md items-center justify-center" }
const _hoisted_160 = ["src"]
const _hoisted_161 = { class: "mt-4 text-sm text-zinc-400 leading-relaxed" }
const _hoisted_162 = { class: "text-sm font-bold text-white uppercase tracking-wider mb-4" }
const _hoisted_163 = { class: "space-y-2.5 text-sm text-zinc-400" }
const _hoisted_164 = {
  href: "#services",
  class: "hover:text-amber-400 transition"
}
const _hoisted_165 = {
  href: "#services",
  class: "hover:text-amber-400 transition"
}
const _hoisted_166 = {
  href: "#destinations",
  class: "hover:text-amber-400 transition"
}
const _hoisted_167 = {
  href: "#family",
  class: "hover:text-amber-400 transition"
}
const _hoisted_168 = {
  href: "#family",
  class: "hover:text-amber-400 transition"
}
const _hoisted_169 = {
  href: "#footer",
  class: "hover:text-amber-400 transition"
}
const _hoisted_170 = { class: "text-sm font-bold text-white uppercase tracking-wider mb-4" }
const _hoisted_171 = { class: "space-y-2.5 text-sm text-zinc-400" }
const _hoisted_172 = { class: "text-sm font-bold text-white uppercase tracking-wider mb-4" }
const _hoisted_173 = { class: "space-y-3 text-sm text-zinc-400" }
const _hoisted_174 = { class: "flex items-start gap-2" }
const _hoisted_175 = { class: "mx-auto max-w-7xl px-4 md:px-6 mt-16 pt-8 border-t border-white/5 text-center text-xs text-zinc-500" }

import { reactive, ref, defineComponent, h, onMounted, onBeforeUnmount, computed } from 'vue'
import { useRouter } from 'vue-router'
import LocationField from '@/components/search/LocationField.vue'
import DateField from '@/components/search/DateField.vue'
import TimeField from '@/components/search/TimeField.vue'
import { getBackendBaseUrl } from '@/utils/common'

// Local Assets
import vwLogo from '@/assets/logo.png'
import vClassImg from '@/assets/cars/van.png'
import familyTripImg from '@/assets/landing/summer/family.png'

// Generated Campaign Images
import heroImageUrl from '@/assets/landing/summer/hero.png'
import bannerImageUrl from '@/assets/landing/summer/banner.png'

// Local Destination Images
import parisImg from '@/assets/landing/summer/paris.png'
import londonImg from '@/assets/landing/summer/london.png'
import switzerlandImg from '@/assets/landing/summer/switzerland.png'
import istanbulImg from '@/assets/landing/summer/istanbul.png'
import romeImg from '@/assets/landing/summer/rome.png'
import bangkokImg from '@/assets/landing/summer/bangkok.png'
import maldivesImg from '@/assets/landing/summer/maldives.png'

const WHATSAPP_NUMBER = '97332141440'
const whatsappMessage = `Hi Vehitra World,
I would like to enquire about your premium transportation services, including airport transfers, chauffeur services, and private travel solutions for my upcoming trip.`

export default /*@__PURE__*/_defineComponent({
  __name: 'LandingPageSummerVacation',
  setup(__props) {

const heroImage = heroImageUrl
const bannerImage = bannerImageUrl

const router = useRouter()
const submitting = ref(false)

// Localization state & dictionary helper
const detectBrowserLanguage = () => {
  if (typeof navigator === 'undefined') return 'en'
  const navLang = navigator.language || (navigator as any).userLanguage || 'en'
  return navLang.toLowerCase().startsWith('ar') ? 'ar' : 'en'
}

const currentLang = ref(localStorage.getItem('preferredLang') || detectBrowserLanguage())

const updateSEOMeta = () => {
  // Title
  document.title = currentLang.value === 'ar'
    ? 'انتقالات المطار الفاخرة وخدمات السائق الخاص لعطلة الصيف — فيترا وورلد'
    : 'Premium Summer Vacation Airport Transfers & Chauffeur Services — Vehitra World'

  // Description
  let metaDesc = document.querySelector('meta[name="description"]')
  if (!metaDesc) {
    metaDesc = document.createElement('meta')
    metaDesc.setAttribute('name', 'description')
    document.head.appendChild(metaDesc)
  }
  metaDesc.setAttribute('content', currentLang.value === 'ar'
    ? 'احجز انتقالات مطار ممتازة وخدمة سائق خاص في جميع أنحاء العالم لعطلتك الصيفية مع فيترا وورلد.'
    : 'Book premium airport transfers and chauffeur services worldwide for your summer vacation with Vehitra World.')

  // Keywords
  let metaKeywords = document.querySelector('meta[name="keywords"]')
  if (!metaKeywords) {
    metaKeywords = document.createElement('meta')
    metaKeywords.setAttribute('name', 'keywords')
    document.head.appendChild(metaKeywords)
  }
  metaKeywords.setAttribute('content', currentLang.value === 'ar'
    ? 'انتقالات المطار، سائق خاص، عطلة الصيف، حجز سيارة، نقل عائلي، فيترا وورلد'
    : 'airport transfers, chauffeur service, summer vacation, car booking, family transfer, Vehitra World')
}

const toggleLang = () => {
  currentLang.value = currentLang.value === 'en' ? 'ar' : 'en'
  localStorage.setItem('preferredLang', currentLang.value)
  updateSEOMeta()
}

onMounted(() => {
  updateSEOMeta()
})

const t = (key: string) => {
  const keys = key.split('.')
  let res: any = translations[currentLang.value]
  for (const k of keys) {
    if (res && res[k]) {
      res = res[k]
    } else {
      return key
    }
  }
  return res
}

const form = reactive({
  name: '',
  phone: '',
  email: '',
  pickup: '',
  dropoff: '',
  datetime: '',
  notes: '',
  serviceType: '',
  passengers: '',
  carType: '',
})

const pickUp = reactive({
  location: { id: '', name: '', isAirport: false, coordinates: { lat: null, lng: null } },
  date: null as string | null,
  time: '' as string
})

const dropOff = reactive({
  location: { id: '', name: '', isAirport: false, coordinates: { lat: null, lng: null } }
})

// WhatsApp Integration
const whatsappUrl = computed(() => `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(whatsappMessage)}`)

// Form event handlers
const onAddressSelected = (address: any, type: 'pickUp' | 'dropOff') => {
  const add = address ?? { id: '', name: '', coordinates: { lat: null, lng: null } }
  if (type === 'pickUp') {
    pickUp.location = add
    form.pickup = add?.name || add?.description || ''
  } else {
    dropOff.location = add
    form.dropoff = add?.name || add?.description || ''
  }
}

const onDateChanged = (d: string) => {
  pickUp.date = d
  form.datetime = [pickUp.date, pickUp.time].filter(Boolean).join(' ')
}

const onTimeChanged = (t: string) => {
  pickUp.time = t
  form.datetime = [pickUp.date, pickUp.time].filter(Boolean).join(' ')
}

const selectDestination = (name: string) => {
  dropOff.location = { id: '', name: name, isAirport: false, coordinates: { lat: null, lng: null } }
  form.dropoff = name
  scrollToForm()
}

const selectVehicleType = (type: string) => {
  form.carType = type
  scrollToForm()
}

const scrollToForm = () => {
  const el = document.getElementById('quote-form-section')
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })
}

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

// Submission
const submitLead = async () => {
  if (!form.serviceType || !form.pickup || !form.dropoff || !form.datetime || !form.passengers || !form.name || !form.phone) {
    alert(currentLang.value === 'ar' ? 'يرجى ملء جميع الحقول المطلوبة المميزة بنجمة *.' : 'Please fill in all required fields marked with *.')
    return
  }

  const API_BASE = getBackendBaseUrl()
  const payload = {
    name: form.name,
    phone: form.phone,
    email: form.email || null,
    pickup: form.pickup,
    dropoff: form.dropoff,
    datetime: form.datetime,
    notes: `Service Type: ${form.serviceType}\n` + (form.notes ? `User Notes: ${form.notes}` : ''),
    source: 'summer-vacation',
    car_type: form.carType || null,
    passengers: Number(form.passengers) || 0,
    suitcases: 0,
    pickUp,
    dropOff,
  }

  submitting.value = true
  try {
    const res = await fetch(`${API_BASE}api/leads/airport-transfer`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload),
    })
    if (!res.ok) {
      const msg = await res.text().catch(() => '')
      throw new Error(`Request failed (${res.status}) ${msg}`)
    }
    router.push({ name: 'ThankYou' })
  } catch (e: any) {
    alert(e?.message || (currentLang.value === 'ar' ? 'حدث خطأ ما أثناء إرسال طلبك.' : 'Something went wrong while submitting your request.'))
  } finally {
    submitting.value = false
  }
}

// Computeds for dynamic locale changes
const localizedServices = computed(() => [
  { title: t('services.airport.title'), description: t('services.airport.desc') },
  { title: t('services.chauffeur.title'), description: t('services.chauffeur.desc') },
  { title: t('services.meet.title'), description: t('services.meet.desc') },
  { title: t('services.family.title'), description: t('services.family.desc') },
  { title: t('services.support.title'), description: t('services.support.desc') }
])

const localizedTestimonials = computed(() => [
  { text: t('testimonials.t1'), author: currentLang.value === 'ar' ? 'عائشة السويدي' : 'Aisha Al Suwaidi', location: currentLang.value === 'ar' ? 'دبي، الإمارات' : 'Dubai, UAE' },
  { text: t('testimonials.t2'), author: currentLang.value === 'ar' ? 'خالد آل ثاني' : 'Khalid Al Thani', location: currentLang.value === 'ar' ? 'الدوحة، قطر' : 'Doha, Qatar' },
  { text: t('testimonials.t3'), author: currentLang.value === 'ar' ? 'فاطمة الحامد' : 'Fatima Al Hamed', location: currentLang.value === 'ar' ? 'البحرين' : 'Bahrain' }
])

// Destinations List Data with localized names
const destinations = [
  { name: 'Paris', arName: 'باريس', image: parisImg },
  { name: 'London', arName: 'لندن', image: londonImg },
  { name: 'Switzerland', arName: 'سويسرا', image: switzerlandImg },
  { name: 'Istanbul', arName: 'إسطنبول', image: istanbulImg },
  { name: 'Rome', arName: 'روما', image: romeImg },
  { name: 'Bangkok', arName: 'بانكوك', image: bangkokImg },
  { name: 'Maldives', arName: 'المالديف', image: maldivesImg },
]

const familyFeatures = [
  { icon: '👶', label: 'Child-Friendly Options (Baby Car Seats)' },
  { icon: '🚐', label: 'Family-Sized Premium Vehicles' },
  { icon: '🛎️', label: 'Airport Assistance & Meet & Greet' },
  { icon: '💼', label: 'Luggage Load & Unload Support' },
  { icon: '☎️', label: '24/7 Priority Customer Care' },
]

const translations: Record<string, any> = {
  en: {
    nav: {
      support: '24/7 Support',
      worldwide: 'We Serve Worldwide',
      airport: 'Airport Transfers',
      chauffeur: 'Chauffeur Services',
      destinations: 'Destinations',
      meet: 'Meet & Greet',
      vehicles: 'Vehicles',
      about: 'About Us',
      bookNow: 'Book Now'
    },
    hero: {
      campaign: 'Summer Campaign 2026',
      title1: 'Your Summer',
      title2: 'Vacation',
      title3: 'Starts Here',
      description1: 'Premium Airport Transfers, Chauffeur Services, Car Rental, Meet & Greet & Buses & Coaches Worldwide.',
      description2: 'From airport pickup and private chauffeur services to car rentals, meet & greet assistance, and group transportation, Vehitra World ensures your summer vacation starts smoothly, comfortably, and stress-free wherever you travel.',
      getQuote: 'GET MY QUOTE',
      whatsapp: 'WHATSAPP NOW',
      gcc: 'Designed For GCC Travelers',
      support: '24/7 Customer Support',
      airportTransfers: 'Worldwide Airport Transfers',
      familyVehicles: 'Family Friendly Vehicles',
      fastConfirmation: 'Fast Booking Confirmation',
      safeService: 'Safe & Reliable Service'
    },
    form: {
      title: 'GET YOUR TRAVEL QUOTE',
      subtitle: 'Fast · Reliable · Worldwide',
      serviceType: 'Service Type*',
      selectService: 'Select Service',
      airport: 'Airport Transfer',
      chauffeur: 'Chauffeur Service / Private Tour',
      carRental: 'Car Rental',
      meetGreet: 'Meet & Greet',
      bus: 'Bus / Coach Group',
      pickup: 'Pick-up Location*',
      dropoff: 'Drop-off Location*',
      date: 'Pick-up Date*',
      time: 'Pick-up Time*',
      passengers: 'Passengers*',
      selectPassengers: 'Select Passengers',
      paxCount: 'Passenger',
      paxCounts: 'Passengers',
      name: 'Your Name*',
      namePlaceholder: 'Enter your name',
      phone: 'WhatsApp / Phone Number*',
      email: 'Email Address (Optional)',
      emailPlaceholder: 'Enter your email address',
      submit: 'GET INSTANT QUOTE',
      submitting: 'Submitting Request…',
      noHidden: 'No Hidden Charges',
      instantConf: 'Instant Confirmation'
    },
    services: {
      tag: 'Our Services',
      title: 'Everything You Need For A Stress-Free Vacation',
      airport: { title: 'Airport Transfers', desc: 'Reliable airport pickup and drop-off in 100+ cities worldwide.' },
      chauffeur: { title: 'Private Chauffeur', desc: 'Professional chauffeurs for business, leisure, and city tours.' },
      meet: { title: 'Meet & Greet', desc: 'Personalized greeting and assistance at the arrivals gate.' },
      family: { title: 'Family Transport', desc: 'Spacious vehicles for families and groups of all sizes.' },
      support: { title: 'Worldwide Support', desc: "We're with you at every step of your journey across the globe." }
    },
    destinations: {
      tag: 'Popular Destinations for GCC Travelers',
      title1: 'Where Will Your Next ',
      title2: 'Summer Adventure',
      title3: ' Be?',
      book: 'Book Now',
      viewAll: 'View All Destinations'
    },
    family: {
      tag: 'TRAVEL TOGETHER. TRAVEL BETTER.',
      title: 'We Make Every Journey ',
      easier: 'Easier',
      desc: 'From kids to grandparents, we ensure a comfortable, safe and stress-free ride for your entire family.',
      child: 'Child-Friendly<br/>Options',
      family: 'Family-Sized<br/>Vehicles',
      airport: 'Airport<br/>Assistance',
      luggage: 'Luggage<br/>Support',
      care: '24/7 Customer<br/>Care',
      btn: 'BOOK FAMILY TRANSFER'
    },
    testimonials: {
      tag: 'Trusted By GCC Travelers',
      title: 'What Our Guests Say',
      t1: 'Booked our Paris airport transfer through Vehitra World. Everything was smooth from arrival to hotel. Highly recommended!',
      t2: 'Excellent chauffeur service during our Switzerland family trip. Very professional, safe driver and strictly on time.',
      t3: 'Best travel experience in Istanbul. The driver was waiting for us and the ride was extremely comfortable.'
    },
    lowerBanner: {
      title1: 'Ready for Your',
      title2: 'Next Adventure?',
      desc: 'Book your premium airport transfer or private chauffeur service today with Vehitra World and travel in complete comfort.',
      quote: 'GET MY QUOTE',
      whatsapp: 'WHATSAPP NOW'
    },
    footer: {
      desc: 'Your trusted travel partner for airport transfers, chauffeur services, and private transportation worldwide.',
      quickLinks: 'Quick Links',
      topDestinations: 'Top Destinations',
      contactUs: 'Contact Us',
      rights: '© 2026 Vehitra World · All Rights Reserved · Privacy Policy · Terms & Conditions'
    }
  },
  ar: {
    nav: {
      support: 'الدعم على مدار الساعة',
      worldwide: 'نخدم جميع أنحاء العالم',
      airport: 'انتقالات المطار',
      chauffeur: 'خدمات السائق الخاص',
      destinations: 'الوجهات',
      meet: 'الاستقبال والمساعدة',
      vehicles: 'السيارات',
      about: 'من نحن',
      bookNow: 'احجز الآن'
    },
    hero: {
      campaign: 'حملة الصيف ٢٠٢٦',
      title1: 'عطلتك الصيفية',
      title2: 'تبدأ',
      title3: 'من هنا',
      description1: 'انتقالات المطار المتميزة، خدمات السائق الخاص، تأجير السيارات، الاستقبال والمساعدة، والحافلات والسيارات الكبيرة حول العالم.',
      description2: 'من الاستقبال في المطار وخدمات السائق الخاص إلى تأجير السيارات والمساعدة في الاستقبال والنقل الجماعي، تضمن لك فيترا وورلد أن تبدأ عطلتك الصيفية بسلاسة وراحة وخلو من الإجهاد أينما كنت مسافراً.',
      getQuote: 'احصل على عرض سعر',
      whatsapp: 'تواصل عبر الواتساب',
      gcc: 'مصمم للمسافرين الخليجيين',
      support: 'دعم العملاء على مدار الساعة',
      airportTransfers: 'انتقالات المطار حول العالم',
      familyVehicles: 'سيارات مناسبة للعائلات',
      fastConfirmation: 'تأكيد حجز سريع',
      safeService: 'خدمة آمنة وموثوقة'
    },
    form: {
      title: 'احصل على عرض سعر السفر',
      subtitle: 'سريع · موثوق · عالمي',
      serviceType: 'نوع الخدمة*',
      selectService: 'اختر الخدمة',
      airport: 'نقل المطار',
      chauffeur: 'خدمة السائق الخاص / جولة خاصة',
      carRental: 'تأجير سيارات',
      meetGreet: 'الاستقبال والمساعدة',
      bus: 'حافلة / باص',
      pickup: 'مكان الاستلام*',
      dropoff: 'مكان التوصيل*',
      date: 'تاريخ الاستلام*',
      time: 'وقت الاستلام*',
      passengers: 'الركاب*',
      selectPassengers: 'اختر عدد الركاب',
      paxCount: 'رافر',
      paxCounts: 'ركاب',
      name: 'الاسم*',
      namePlaceholder: 'أدخل اسمك',
      phone: 'رقم الواتساب / الهاتف*',
      email: 'البريد الإلكتروني (اختياري)',
      emailPlaceholder: 'أدخل البريد الإلكتروني الخاص بك',
      submit: 'احصل على عرض سعر فوري',
      submitting: 'جاري إرسال الطلب…',
      noHidden: 'لا توجد رسوم خفية',
      instantConf: 'تأكيد فوري'
    },
    services: {
      tag: 'خدماتنا',
      title: 'كل ما تحتاجه لعطلة صيفية خالية من القلق',
      airport: { title: 'انتقالات المطار', desc: 'نقل موثوق من وإلى المطار في أكثر من ١٠٠ مدينة حول العالم.' },
      chauffeur: { title: 'سائق خاص', desc: 'سائقون محترفون للأعمال والترفيه والجولات السياحية في المدينة.' },
      meet: { title: 'الاستقبال والمساعدة', desc: 'استقبال شخصي ومساعدة عند بوابة الوصول بالمطار.' },
      family: { title: 'نقل العائلات', desc: 'سيارات واسعة ومريحة للعائلات والمجموعات بجميع الأحجام.' },
      support: { title: 'دعم عالمي', desc: 'نحن معك في كل خطوة من رحلتك في جميع أنحاء العالم.' }
    },
    destinations: {
      tag: 'الوجهات المفضلة للمسافرين الخليجيين',
      title1: 'أين ستكون مغامرتك ',
      title2: 'الصيفية القادمة',
      title3: '؟',
      book: 'احجز الآن',
      viewAll: 'عرض جميع الوجهات'
    },
    family: {
      tag: 'سافروا معاً، لتجربة أفضل.',
      title: 'نجعل كل رحلة ',
      easier: 'أسهل',
      desc: 'من الأطفال إلى الأجداد، نضمن رحلة مريحة وآمنة وخالية من القلق لجميع أفراد عائلتك.',
      child: 'خيارات مناسبة<br/>للأطفال',
      family: 'سيارات بحجم<br/>عائلي',
      airport: 'مساعدة في<br/>المطار',
      luggage: 'مساعدة في<br/>الأمتعة',
      care: 'رعاية العملاء<br/>على مدار الساعة',
      btn: 'احجز نقل عائلي'
    },
    testimonials: {
      tag: 'موثوق من المسافرين الخليجيين',
      title: 'ماذا يقول ضيوفنا',
      t1: 'حجزنا انتقالات المطار في باريس عبر فيترا وورلد. كان كل شيء سهلاً ومريحاً من لحظة وصولنا حتى الفندق. ننصح بهم بشدة!',
      t2: 'خدمة سائق ممتازة خلال رحلتنا العائلية إلى سويسرا. سائق محترف وآمن وملتزم بالوقت تماماً.',
      t3: 'أفضل تجربة سفر في إسطنبول. كان السائق في انتظارنا وكانت الرحلة مريحة للغاية.'
    },
    lowerBanner: {
      title1: 'هل أنت مستعد لـ',
      title2: 'مغامرتك القادمة؟',
      desc: 'احجز نقل المطار المميز أو خدمة السائق الخاص اليوم مع فيترا وورلد وسافر براحة تامة.',
      quote: 'احصل على عرض سعر',
      whatsapp: 'تواصل عبر الواتساب'
    },
    footer: {
      desc: 'شريكك الموثوق للسفر لانتقالات المطار، خدمات السائق الخاص، والنقل الخاص في جميع أنحاء العالم.',
      quickLinks: 'روابط سريعة',
      topDestinations: 'أشهر الوجهات',
      contactUs: 'اتصل بنا',
      rights: '© ٢٠٢٦ فيترا وورلد · جميع الحقوق محفوظة · سياسة الخصوصية · الشروط والأحكام'
    }
  }
}

/* ---------- Google Places PAC dropdown styling patch ---------- */
function usePatchPacDropdown() {
  const getFocusedInput = (): HTMLInputElement | null =>
    document.activeElement?.tagName === 'INPUT'
      ? (document.activeElement as HTMLInputElement)
      : (document.querySelector('.lead-form input:focus') as HTMLInputElement | null)

  const apply = () => {
    const pacs = document.querySelectorAll<HTMLElement>('.pac-container')
    if (!pacs.length) return
    const input = getFocusedInput() || (document.querySelector('.lead-form input') as HTMLInputElement | null)
    if (!input) return
    const r = input.getBoundingClientRect()
    const desiredWidth = Math.max(r.width + 40, 500)
    pacs.forEach(pac => {
      pac.style.setProperty('position', 'fixed', 'important')
      pac.style.setProperty('left', `${r.left}px`, 'important')
      pac.style.setProperty('top', `${r.bottom}px`, 'important')
      pac.style.setProperty('width', `${desiredWidth}px`, 'important')
      pac.style.setProperty('minWidth', `${desiredWidth}px`, 'important')
      pac.style.setProperty('maxWidth', `${desiredWidth}px`, 'important')
      pac.style.setProperty('maxHeight', '400px', 'important')
      pac.style.setProperty('overflowY', 'auto', 'important')
      pac.style.setProperty('overflowX', 'hidden', 'important')
      pac.style.setProperty('zIndex', '99999', 'important')
      pac.style.setProperty('borderRadius', '16px', 'important')
      pac.style.setProperty('border', '1px solid rgba(255,255,255,.12)', 'important')
      pac.style.setProperty('background', 'rgba(11,14,17,.98)', 'important')
      pac.style.setProperty('boxShadow', '0 20px 50px rgba(0,0,0,.6)', 'important')
      pac.style.setProperty('padding', '6px 0', 'important')
    })
  }

  const onFocusIn  = () => setTimeout(() => { apply() }, 50)
  const onResize   = () => apply()
  const onScroll   = () => apply()

  onMounted(() => {
    document.addEventListener('focusin', onFocusIn, true)
    window.addEventListener('resize', onResize)
    window.addEventListener('scroll', onScroll, true)
    const mo = new MutationObserver(apply)
    mo.observe(document.body, { childList: true, subtree: true })
  })
  onBeforeUnmount(() => {
    document.removeEventListener('focusin', onFocusIn, true)
    window.removeEventListener('resize', onResize)
    window.removeEventListener('scroll', onScroll, true)
  })
}
usePatchPacDropdown()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    dir: currentLang.value === 'ar' ? 'rtl' : 'ltr',
    class: _normalizeClass([currentLang.value === 'ar' ? 'font-arabic' : 'font-outfit', "min-h-screen bg-[#07090b] text-white overflow-x-hidden text-start"])
  }, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-amber-400" }, "📞", -1)),
              _createTextVNode(" " + _toDisplayString(t('nav.support')) + ": +973 3214 1440 ", 1)
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "hidden items-center gap-1.5 opacity-80 sm:flex" }, [
              _createElementVNode("span", { class: "text-amber-400" }, "✉️"),
              _createTextVNode(" support@vehitraworld.com ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-amber-400" }, "🌍", -1)),
              _createTextVNode(" " + _toDisplayString(t('nav.worldwide')), 1)
            ]),
            _createElementVNode("button", {
              onClick: toggleLang,
              class: "flex items-center gap-1.5 opacity-85 hover:opacity-100 hover:text-amber-400 focus:outline-none bg-transparent border-none font-semibold text-[11px] md:text-xs cursor-pointer transition"
            }, [
              _createElementVNode("span", null, _toDisplayString(currentLang.value === 'ar' ? '🇬🇧' : '🇧🇭'), 1),
              _createElementVNode("span", null, _toDisplayString(currentLang.value === 'ar' ? 'English' : 'العربية'), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              src: _unref(vwLogo),
              alt: "Vehitra World",
              class: "h-9 w-auto object-contain cursor-pointer",
              onClick: scrollToTop
            }, null, 8, _hoisted_12)
          ])
        ]),
        _createElementVNode("nav", _hoisted_13, [
          _createElementVNode("a", _hoisted_14, _toDisplayString(t('nav.airport')), 1),
          _createElementVNode("a", _hoisted_15, _toDisplayString(t('nav.chauffeur')), 1),
          _createElementVNode("a", _hoisted_16, _toDisplayString(t('nav.destinations')), 1),
          _createElementVNode("a", _hoisted_17, _toDisplayString(t('nav.meet')), 1),
          _createElementVNode("a", _hoisted_18, _toDisplayString(t('nav.vehicles')), 1),
          _createElementVNode("a", _hoisted_19, _toDisplayString(t('nav.about')), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            onClick: scrollToForm,
            class: "rounded-full bg-amber-500 hover:bg-amber-400 px-6 py-2.5 text-xs md:text-sm font-bold text-[#07090b] uppercase tracking-wider transition shadow-lg shadow-amber-500/20 active:scale-95"
          }, _toDisplayString(t('nav.bookNow')), 1)
        ])
      ])
    ]),
    _createElementVNode("section", {
      class: "relative min-h-[90vh] flex items-center py-10 md:py-16 bg-cover bg-center",
      style: _normalizeStyle({ backgroundImage: `linear-gradient(rgba(7,9,11,0.7), rgba(7,9,11,0.85)), url(${_unref(heroImage)})` })
    }, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("span", _hoisted_22, " 🌴 " + _toDisplayString(t('hero.campaign')), 1),
          _createElementVNode("h1", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(t('hero.title1')), 1),
            _createElementVNode("span", _hoisted_25, _toDisplayString(t('hero.title2')), 1),
            _createElementVNode("span", _hoisted_26, _toDisplayString(t('hero.title3')), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("p", _hoisted_28, _toDisplayString(t('hero.description1')), 1),
            _createElementVNode("p", _hoisted_29, _toDisplayString(t('hero.description2')), 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("button", {
              onClick: scrollToForm,
              class: "inline-flex items-center justify-center rounded-full bg-amber-500 hover:bg-amber-400 px-8 py-4 text-sm md:text-base font-bold text-[#07090b] transition shadow-lg shadow-amber-500/30 active:scale-95"
            }, [
              _createTextVNode(_toDisplayString(t('hero.getQuote')) + " ", 1),
              _createElementVNode("span", {
                class: _normalizeClass(["mx-2", currentLang.value === 'ar' ? 'rotate-180 inline-block' : ''])
              }, "→", 2)
            ]),
            _createElementVNode("a", {
              href: whatsappUrl.value,
              target: "_blank",
              class: "inline-flex items-center justify-center rounded-full bg-emerald-600 hover:bg-emerald-500 px-8 py-4 text-sm md:text-base font-bold text-white transition active:scale-95"
            }, _toDisplayString(t('hero.whatsapp')), 9, _hoisted_31)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _cache[17] || (_cache[17] = _createElementVNode("svg", {
                class: "h-5 w-5 text-amber-500 flex-shrink-0",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "1.8"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M3 18.75V7.5a.75.75 0 011.13-.65l3.87 2.325 3.19-4.786a.75.75 0 011.24 0l3.19 4.786 3.87-2.325a.75.75 0 011.13.65v11.25M3 18.75h18M3 18.75a2.25 2.25 0 002.25 2.25h13.5a2.25 2.25 0 002.25-2.25"
                })
              ], -1)),
              _createElementVNode("span", _hoisted_34, _toDisplayString(t('hero.gcc')), 1)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _cache[18] || (_cache[18] = _createElementVNode("svg", {
                class: "h-5 w-5 text-amber-500 flex-shrink-0",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "1.8"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M3.75 12a8.25 8.25 0 0116.5 0v5.25a2.25 2.25 0 01-2.25 2.25h-1.5a2.25 2.25 0 01-2.25-2.25V15a2.25 2.25 0 012.25-2.25h3m-16.5 0h3A2.25 2.25 0 019 15v2.25a2.25 2.25 0 01-2.25 2.25h-1.5A2.25 2.25 0 013 17.25V12z"
                })
              ], -1)),
              _createElementVNode("span", _hoisted_36, _toDisplayString(t('hero.support')), 1)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _cache[19] || (_cache[19] = _createElementVNode("svg", {
                class: "h-5 w-5 text-amber-500 flex-shrink-0",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "1.8"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M10 21l1.5-2.5L10 12l6 1.5 2-1.5-1.5-1.5-6.5-.5L9 5l-1.5-1.5-6.5 7l-2-1L3.5 8.5l4 3.5-3 5H6l2.5-3.5L10 21z"
                })
              ], -1)),
              _createElementVNode("span", _hoisted_38, _toDisplayString(t('hero.airportTransfers')), 1)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _cache[20] || (_cache[20] = _createElementVNode("svg", {
                class: "h-5 w-5 text-amber-500 flex-shrink-0",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "1.8"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M8.25 18.75a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM15.75 18.75a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
                }),
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M3 14.25v-2.25a2.25 2.25 0 012.25-2.25h9.75L17.25 6h3.75a.75.75 0 01.75.75v7.5M3 14.25h19v2.25H3v-2.25z"
                })
              ], -1)),
              _createElementVNode("span", _hoisted_40, _toDisplayString(t('hero.familyVehicles')), 1)
            ]),
            _createElementVNode("div", _hoisted_41, [
              _cache[21] || (_cache[21] = _createElementVNode("svg", {
                class: "h-5 w-5 text-amber-500 flex-shrink-0",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "1.8"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                })
              ], -1)),
              _createElementVNode("span", _hoisted_42, _toDisplayString(t('hero.fastConfirmation')), 1)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _cache[22] || (_cache[22] = _createElementVNode("svg", {
                class: "h-5 w-5 text-amber-500 flex-shrink-0",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "1.8"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
                })
              ], -1)),
              _createElementVNode("span", _hoisted_44, _toDisplayString(t('hero.safeService')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("h2", _hoisted_47, _toDisplayString(t('form.title')), 1),
            _createElementVNode("p", _hoisted_48, _toDisplayString(t('form.subtitle')), 1),
            _createElementVNode("form", {
              onSubmit: _withModifiers(submitLead, ["prevent"]),
              class: "lead-form mt-6 flex flex-col gap-4"
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_49, _toDisplayString(t('form.serviceType')), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.serviceType) = $event)),
                  class: "form-input select-arrow"
                }, [
                  _createElementVNode("option", _hoisted_50, _toDisplayString(t('form.selectService')), 1),
                  _createElementVNode("option", _hoisted_51, _toDisplayString(t('form.airport')), 1),
                  _createElementVNode("option", _hoisted_52, _toDisplayString(t('form.chauffeur')), 1),
                  _createElementVNode("option", _hoisted_53, _toDisplayString(t('form.carRental')), 1),
                  _createElementVNode("option", _hoisted_54, _toDisplayString(t('form.meetGreet')), 1),
                  _createElementVNode("option", _hoisted_55, _toDisplayString(t('form.bus')), 1)
                ], 512), [
                  [_vModelSelect, form.serviceType]
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createVNode(LocationField, {
                  class: "field-reset af-loc",
                  layout: 'simple',
                  drive: 'distance',
                  hasError: false,
                  data: pickUp,
                  type: "pickUp",
                  label: t('form.pickup'),
                  onAddressSelected: _cache[1] || (_cache[1] = addr => onAddressSelected(addr, 'pickUp'))
                }, null, 8, ["data", "label"])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createVNode(LocationField, {
                  class: "field-reset af-loc",
                  layout: 'simple',
                  drive: 'distance',
                  hasError: false,
                  data: dropOff,
                  type: "dropOff",
                  label: t('form.dropoff'),
                  onAddressSelected: _cache[2] || (_cache[2] = addr => onAddressSelected(addr, 'dropOff'))
                }, null, 8, ["data", "label"])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createVNode(DateField, {
                    class: "field-reset af-dt",
                    layout: 'simple',
                    hasError: false,
                    data: pickUp.date,
                    label: t('form.date'),
                    onDateChanged: onDateChanged
                  }, null, 8, ["data", "label"])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(TimeField, {
                    class: "field-reset af-dt",
                    layout: 'simple',
                    hasError: false,
                    data: pickUp.time,
                    label: t('form.time'),
                    onTimeChanged: onTimeChanged
                  }, null, 8, ["data", "label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_62, _toDisplayString(t('form.passengers')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.passengers) = $event)),
                    class: "form-input select-arrow"
                  }, [
                    _createElementVNode("option", _hoisted_63, _toDisplayString(t('form.selectPassengers')), 1),
                    _createElementVNode("option", _hoisted_64, "1 " + _toDisplayString(currentLang.value === 'ar' ? 'راكب' : t('form.paxCount')), 1),
                    _createElementVNode("option", _hoisted_65, "2 " + _toDisplayString(currentLang.value === 'ar' ? 'ركاب' : t('form.paxCounts')), 1),
                    _createElementVNode("option", _hoisted_66, "3 " + _toDisplayString(currentLang.value === 'ar' ? 'ركاب' : t('form.paxCounts')), 1),
                    _createElementVNode("option", _hoisted_67, "4 " + _toDisplayString(currentLang.value === 'ar' ? 'ركاب' : t('form.paxCounts')), 1),
                    _createElementVNode("option", _hoisted_68, "5 " + _toDisplayString(currentLang.value === 'ar' ? 'ركاب' : t('form.paxCounts')), 1),
                    _createElementVNode("option", _hoisted_69, "6 " + _toDisplayString(currentLang.value === 'ar' ? 'ركاب' : t('form.paxCounts')), 1),
                    _createElementVNode("option", _hoisted_70, "7+ " + _toDisplayString(currentLang.value === 'ar' ? 'ركاب' : t('form.paxCounts')), 1)
                  ], 512), [
                    [_vModelSelect, form.passengers]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_71, _toDisplayString(t('form.name')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-input",
                    placeholder: t('form.namePlaceholder'),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.name) = $event))
                  }, null, 8, _hoisted_72), [
                    [_vModelText, form.name]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_73, _toDisplayString(t('form.phone')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-input",
                  placeholder: "e.g. +973 3214 1440",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.phone) = $event))
                }, null, 512), [
                  [_vModelText, form.phone]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_74, _toDisplayString(t('form.email')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: "form-input",
                  placeholder: t('form.emailPlaceholder'),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.email) = $event))
                }, null, 8, _hoisted_75), [
                  [_vModelText, form.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("button", {
                  type: "submit",
                  disabled: submitting.value,
                  class: "btn-primary"
                }, _toDisplayString(submitting.value ? t('form.submitting') : t('form.submit')), 9, _hoisted_77),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("span", _hoisted_79, [
                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-amber-500" }, "✔", -1)),
                    _createTextVNode(" " + _toDisplayString(t('form.noHidden')), 1)
                  ]),
                  _createElementVNode("span", _hoisted_80, [
                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-amber-500" }, "✔", -1)),
                    _createTextVNode(" " + _toDisplayString(t('form.instantConf')), 1)
                  ])
                ])
              ])
            ], 32)
          ])
        ])
      ])
    ], 4),
    _createElementVNode("section", _hoisted_81, [
      _createElementVNode("div", _hoisted_82, [
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("span", _hoisted_84, _toDisplayString(t('services.tag')), 1),
          _createElementVNode("h2", _hoisted_85, _toDisplayString(t('services.title')), 1),
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "mt-3 mx-auto w-16 h-1 bg-amber-500 rounded-full" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_86, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localizedServices.value, (svc) => {
            return (_openBlock(), _createElementBlock("div", {
              key: svc.title,
              class: "service-card group"
            }, [
              _createElementVNode("div", _hoisted_87, [
                (svc.title === t('services.airport.title'))
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_88, _cache[26] || (_cache[26] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M10 21l1.5-2.5L10 12l6 1.5 2-1.5-1.5-1.5-6.5-.5L9 5l-1.5-1.5-6.5 7l-2-1L3.5 8.5l4 3.5-3 5H6l2.5-3.5L10 21z"
                      }, null, -1)
                    ])))
                  : (svc.title === t('services.chauffeur.title'))
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_89, _cache[27] || (_cache[27] = [
                        _createElementVNode("circle", {
                          cx: "12",
                          cy: "12",
                          r: "9"
                        }, null, -1),
                        _createElementVNode("circle", {
                          cx: "12",
                          cy: "12",
                          r: "3"
                        }, null, -1),
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M12 3v6M12 15v6M3 12h6M15 12h6"
                        }, null, -1)
                      ])))
                    : (svc.title === t('services.meet.title'))
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_90, _cache[28] || (_cache[28] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            d: "M10.05 13.05a3.536 3.536 0 00-5 0l-1 1a3.536 3.536 0 005 5l1-1a3.536 3.536 0 000-5M13.95 10.95a3.536 3.536 0 005 0l1-1a3.536 3.536 0 00-5-5l-1 1a3.536 3.536 0 000 5M10 14l4-4"
                          }, null, -1)
                        ])))
                      : (svc.title === t('services.family.title'))
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_91, _cache[29] || (_cache[29] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              d: "M8.25 18.75a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM15.75 18.75a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
                            }, null, -1),
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              d: "M3 14.25v-2.25a2.25 2.25 0 012.25-2.25h9.75L17.25 6h3.75a.75.75 0 01.75.75v7.5M3 14.25h19v2.25H3v-2.25z"
                            }, null, -1)
                          ])))
                        : (svc.title === t('services.support.title'))
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_92, _cache[30] || (_cache[30] = [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "M12 21a9 9 0 100-18 9 9 0 000 18z"
                              }, null, -1),
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "M3.6 9h16.8M3.6 15h16.8"
                              }, null, -1),
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "M11.5 3a17 17 0 000 18M12.5 3a17 17 0 000 18"
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true)
              ]),
              _createElementVNode("h3", _hoisted_93, _toDisplayString(svc.title), 1),
              _createElementVNode("p", _hoisted_94, _toDisplayString(svc.description), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_95, [
      _createElementVNode("div", _hoisted_96, [
        _createElementVNode("div", _hoisted_97, [
          _createElementVNode("span", _hoisted_98, _toDisplayString(t('destinations.tag')), 1),
          _createElementVNode("h2", _hoisted_99, [
            _createTextVNode(_toDisplayString(t('destinations.title1')), 1),
            _createElementVNode("span", _hoisted_100, _toDisplayString(t('destinations.title2')), 1),
            _createTextVNode(_toDisplayString(t('destinations.title3')), 1)
          ]),
          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "mt-3 mx-auto w-16 h-1 bg-amber-500 rounded-full" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_101, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(destinations, (dest) => {
            return _createElementVNode("div", {
              key: dest.name,
              onClick: ($event: any) => (selectDestination(dest.name)),
              class: "destination-card group"
            }, [
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("img", {
                  src: dest.image,
                  alt: dest.name,
                  class: "h-full w-full object-cover group-hover:scale-110 transition-transform duration-500"
                }, null, 8, _hoisted_104),
                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-t from-black/90 via-black/35 to-transparent" }, null, -1)),
                _createElementVNode("div", _hoisted_105, [
                  _createElementVNode("h3", _hoisted_106, _toDisplayString(currentLang.value === 'ar' ? dest.arName : dest.name), 1),
                  _createElementVNode("span", _hoisted_107, [
                    _createTextVNode(_toDisplayString(t('destinations.book')) + " ", 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["mx-1", currentLang.value === 'ar' ? 'rotate-180 inline-block' : ''])
                    }, "→", 2)
                  ])
                ])
              ])
            ], 8, _hoisted_102)
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_108, [
          _createElementVNode("button", {
            onClick: scrollToForm,
            class: "rounded-full border border-white/20 hover:border-amber-500 hover:text-amber-400 px-8 py-3 text-xs md:text-sm font-bold uppercase tracking-wider transition"
          }, _toDisplayString(t('destinations.viewAll')), 1)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_109, [
      _createElementVNode("div", _hoisted_110, [
        _createElementVNode("div", _hoisted_111, [
          _createElementVNode("div", _hoisted_112, [
            _createElementVNode("img", {
              src: _unref(familyTripImg),
              alt: "Family Vacation Group",
              class: "w-full h-full object-cover aspect-[4/3] lg:aspect-auto"
            }, null, 8, _hoisted_113)
          ]),
          _createElementVNode("div", _hoisted_114, [
            _createElementVNode("span", _hoisted_115, _toDisplayString(t('family.tag')), 1),
            _createElementVNode("h2", _hoisted_116, [
              _createTextVNode(_toDisplayString(t('family.title')), 1),
              _createElementVNode("span", _hoisted_117, _toDisplayString(t('family.easier')), 1)
            ]),
            _createElementVNode("div", _hoisted_118, [
              _createElementVNode("div", _hoisted_119, [
                _cache[33] || (_cache[33] = _createElementVNode("svg", {
                  class: "h-6 w-6 text-zinc-800",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "stroke-width": "1.5"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 14a4 4 0 100-8 4 4 0 000 8z"
                  }),
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 2v4M7 6c0-2 2-3 5-3s5 1 5 3M6.5 17.5a6 6 0 0111 0"
                  })
                ], -1)),
                _createElementVNode("span", {
                  class: "mt-1 text-[8px] font-bold text-zinc-800 leading-tight text-center",
                  innerHTML: t('family.child')
                }, null, 8, _hoisted_120)
              ]),
              _cache[38] || (_cache[38] = _createElementVNode("span", { class: "text-zinc-400 font-bold text-sm flex-shrink-0" }, "+", -1)),
              _createElementVNode("div", _hoisted_121, [
                _cache[34] || (_cache[34] = _createElementVNode("svg", {
                  class: "h-6 w-6 text-zinc-800",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "stroke-width": "1.5"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M5 16a2 2 0 100-4 2 2 0 000 4z"
                  }),
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M19 16a2 2 0 100-4 2 2 0 000 4z"
                  }),
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M2 13h20v-3a2 2 0 00-2-2H4a2 2 0 00-2 2v3zM6 8V6a1 1 0 011-1h10a1 1 0 011 1v2"
                  })
                ], -1)),
                _createElementVNode("span", {
                  class: "mt-1 text-[8px] font-bold text-zinc-800 leading-tight text-center",
                  innerHTML: t('family.family')
                }, null, 8, _hoisted_122)
              ]),
              _cache[39] || (_cache[39] = _createElementVNode("span", { class: "text-zinc-400 font-bold text-sm flex-shrink-0" }, "+", -1)),
              _createElementVNode("div", _hoisted_123, [
                _cache[35] || (_cache[35] = _createElementVNode("svg", {
                  class: "h-6 w-6 text-zinc-800",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "stroke-width": "1.5"
                }, [
                  _createElementVNode("circle", {
                    cx: "12",
                    cy: "6",
                    r: "3"
                  }),
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M6 20v-2a4 4 0 014-4h4a4 4 0 014 4v2"
                  }),
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M9 10l3-3 3 3"
                  })
                ], -1)),
                _createElementVNode("span", {
                  class: "mt-1 text-[8px] font-bold text-zinc-800 leading-tight text-center",
                  innerHTML: t('family.airport')
                }, null, 8, _hoisted_124)
              ]),
              _cache[40] || (_cache[40] = _createElementVNode("span", { class: "text-zinc-400 font-bold text-sm flex-shrink-0" }, "+", -1)),
              _createElementVNode("div", _hoisted_125, [
                _cache[36] || (_cache[36] = _createElementVNode("svg", {
                  class: "h-6 w-6 text-zinc-800",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "stroke-width": "1.5"
                }, [
                  _createElementVNode("rect", {
                    x: "5",
                    y: "7",
                    width: "14",
                    height: "12",
                    rx: "1.5"
                  }),
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M9 7V4a2 2 0 012-2h2a2 2 0 012 2v3M9 11v4M15 11v4"
                  })
                ], -1)),
                _createElementVNode("span", {
                  class: "mt-1 text-[8px] font-bold text-zinc-800 leading-tight text-center",
                  innerHTML: t('family.luggage')
                }, null, 8, _hoisted_126)
              ]),
              _cache[41] || (_cache[41] = _createElementVNode("span", { class: "text-zinc-400 font-bold text-sm flex-shrink-0" }, "+", -1)),
              _createElementVNode("div", _hoisted_127, [
                _cache[37] || (_cache[37] = _createElementVNode("svg", {
                  class: "h-6 w-6 text-zinc-800",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "stroke-width": "1.5"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M3 12c0-4.97 4.03-9 9-9s9 4.03 9 9v7a2 2 0 01-2 2h-3a2 2 0 01-2-2v-3a2 2 0 012-2h3M3 12h3a2 2 0 012 2v3a2 2 0 01-2 2H3M19 16v1a2 2 0 01-2 2h-2"
                  })
                ], -1)),
                _createElementVNode("span", {
                  class: "mt-1 text-[8px] font-bold text-zinc-800 leading-tight text-center",
                  innerHTML: t('family.care')
                }, null, 8, _hoisted_128)
              ])
            ]),
            _createElementVNode("p", _hoisted_129, _toDisplayString(t('family.desc')), 1),
            _createElementVNode("div", _hoisted_130, [
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (selectVehicleType('Van'))),
                class: "rounded-md bg-[#030506] hover:bg-amber-500 text-white hover:text-[#030506] px-7 py-3.5 text-xs font-bold uppercase tracking-wider transition duration-300 flex items-center gap-2 shadow-md"
              }, [
                _createTextVNode(_toDisplayString(t('family.btn')) + " ", 1),
                _createElementVNode("span", {
                  class: _normalizeClass(currentLang.value === 'ar' ? 'rotate-180 inline-block' : '')
                }, "→", 2)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_131, [
            _createElementVNode("img", {
              src: _unref(vClassImg),
              alt: "Mercedes V-Class",
              class: "w-full h-auto max-h-[260px] object-contain hover:scale-105 transition-transform duration-300"
            }, null, 8, _hoisted_132)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_133, [
      _createElementVNode("div", _hoisted_134, [
        _createElementVNode("div", _hoisted_135, [
          _createElementVNode("span", _hoisted_136, _toDisplayString(t('testimonials.tag')), 1),
          _createElementVNode("h2", _hoisted_137, _toDisplayString(t('testimonials.title')), 1),
          _cache[42] || (_cache[42] = _createElementVNode("div", { class: "mt-3 mx-auto w-16 h-1 bg-amber-500 rounded-full" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_138, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localizedTestimonials.value, (t) => {
            return (_openBlock(), _createElementBlock("div", {
              key: t.author,
              class: "testimonial-card relative"
            }, [
              _cache[43] || (_cache[43] = _createElementVNode("span", { class: "absolute top-6 right-8 text-6xl text-amber-500/10 font-serif" }, "“", -1)),
              _cache[44] || (_cache[44] = _createElementVNode("div", { class: "mb-4 text-amber-400" }, "★★★★★", -1)),
              _createElementVNode("p", _hoisted_139, "“" + _toDisplayString(t.text) + "”", 1),
              _createElementVNode("div", _hoisted_140, [
                _createElementVNode("h4", _hoisted_141, _toDisplayString(t.author), 1),
                _createElementVNode("p", _hoisted_142, _toDisplayString(t.location), 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("section", {
      class: "relative py-24 bg-cover bg-center border-t border-white/10",
      style: _normalizeStyle({ backgroundImage: `linear-gradient(rgba(7,9,11,0.85), rgba(7,9,11,0.9)), url(${_unref(bannerImage)})` })
    }, [
      _createElementVNode("div", _hoisted_143, [
        _createElementVNode("h2", _hoisted_144, [
          _createTextVNode(_toDisplayString(t('lowerBanner.title1')) + " ", 1),
          _createElementVNode("span", _hoisted_145, _toDisplayString(t('lowerBanner.title2')), 1)
        ]),
        _createElementVNode("p", _hoisted_146, _toDisplayString(t('lowerBanner.desc')), 1),
        _createElementVNode("div", _hoisted_147, [
          _createElementVNode("button", {
            onClick: scrollToForm,
            class: "rounded-full bg-amber-500 hover:bg-amber-400 px-8 py-4 text-sm md:text-base font-bold text-[#07090b] transition shadow-lg shadow-amber-500/30 active:scale-95"
          }, [
            _createTextVNode(_toDisplayString(t('lowerBanner.quote')) + " ", 1),
            _createElementVNode("span", {
              class: _normalizeClass(["mx-2", currentLang.value === 'ar' ? 'rotate-180 inline-block' : ''])
            }, "→", 2)
          ]),
          _createElementVNode("a", {
            href: whatsappUrl.value,
            target: "_blank",
            class: "rounded-full bg-emerald-600 hover:bg-emerald-500 px-8 py-4 text-sm md:text-base font-bold text-white transition active:scale-95"
          }, _toDisplayString(t('lowerBanner.whatsapp')), 9, _hoisted_148)
        ]),
        _createElementVNode("div", _hoisted_149, [
          _createElementVNode("div", null, [
            _cache[45] || (_cache[45] = _createElementVNode("div", { class: "text-xl md:text-2xl font-bold text-amber-400" }, "100+", -1)),
            _createElementVNode("div", _hoisted_150, _toDisplayString(currentLang.value === 'ar' ? 'دولة وأكثر' : 'Countries Covered'), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[46] || (_cache[46] = _createElementVNode("div", { class: "text-xl md:text-2xl font-bold text-amber-400" }, "10,000+", -1)),
            _createElementVNode("div", _hoisted_151, _toDisplayString(currentLang.value === 'ar' ? 'عميل سعيد' : 'Happy Customers'), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[47] || (_cache[47] = _createElementVNode("div", { class: "text-xl md:text-2xl font-bold text-amber-400" }, "500+", -1)),
            _createElementVNode("div", _hoisted_152, _toDisplayString(currentLang.value === 'ar' ? 'مدينة حول العالم' : 'Cities Worldwide'), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[48] || (_cache[48] = _createElementVNode("div", { class: "text-xl md:text-2xl font-bold text-amber-400" }, "24/7", -1)),
            _createElementVNode("div", _hoisted_153, _toDisplayString(currentLang.value === 'ar' ? 'دعم مستمر' : 'Customer Support'), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[49] || (_cache[49] = _createElementVNode("div", { class: "text-xl md:text-2xl font-bold text-amber-400" }, "100%", -1)),
            _createElementVNode("div", _hoisted_154, _toDisplayString(currentLang.value === 'ar' ? 'رضا مضمون' : 'Satisfaction Guaranteed'), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_155, _toDisplayString(currentLang.value === 'ar' ? 'آمن' : 'Secure'), 1),
            _createElementVNode("div", _hoisted_156, _toDisplayString(currentLang.value === 'ar' ? 'حجز سهل وموثوق' : '& Easy Booking'), 1)
          ])
        ])
      ])
    ], 4),
    _createElementVNode("footer", _hoisted_157, [
      _createElementVNode("div", _hoisted_158, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_159, [
            _createElementVNode("img", {
              src: _unref(vwLogo),
              alt: "Vehitra World",
              class: "h-9 w-auto object-contain"
            }, null, 8, _hoisted_160)
          ]),
          _createElementVNode("p", _hoisted_161, _toDisplayString(t('footer.desc')), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("h4", _hoisted_162, _toDisplayString(t('footer.quickLinks')), 1),
          _createElementVNode("ul", _hoisted_163, [
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_164, _toDisplayString(t('nav.airport')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_165, _toDisplayString(t('nav.chauffeur')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_166, _toDisplayString(t('nav.destinations')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_167, _toDisplayString(t('nav.meet')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_168, _toDisplayString(t('nav.vehicles')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_169, _toDisplayString(t('nav.about')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("h4", _hoisted_170, _toDisplayString(t('footer.topDestinations')), 1),
          _createElementVNode("ul", _hoisted_171, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "#destinations",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (selectDestination('Paris'))),
                class: "hover:text-amber-400 transition"
              }, _toDisplayString(currentLang.value === 'ar' ? 'باريس، فرنسا' : 'Paris, France'), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "#destinations",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (selectDestination('London'))),
                class: "hover:text-amber-400 transition"
              }, _toDisplayString(currentLang.value === 'ar' ? 'لندن، المملكة المتحدة' : 'London, United Kingdom'), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "#destinations",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (selectDestination('Switzerland'))),
                class: "hover:text-amber-400 transition"
              }, _toDisplayString(currentLang.value === 'ar' ? 'سويسرا، جبال الألب' : 'Switzerland, Alps'), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "#destinations",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (selectDestination('Istanbul'))),
                class: "hover:text-amber-400 transition"
              }, _toDisplayString(currentLang.value === 'ar' ? 'إسطنبول، تركيا' : 'Istanbul, Turkey'), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "#destinations",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (selectDestination('Rome'))),
                class: "hover:text-amber-400 transition"
              }, _toDisplayString(currentLang.value === 'ar' ? 'روما، إيطاليا' : 'Rome, Italy'), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "#destinations",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (selectDestination('Maldives'))),
                class: "hover:text-amber-400 transition"
              }, _toDisplayString(currentLang.value === 'ar' ? 'جزر المالديف' : 'Maldives Islands'), 1)
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("h4", _hoisted_172, _toDisplayString(t('footer.contactUs')), 1),
          _createElementVNode("ul", _hoisted_173, [
            _cache[51] || (_cache[51] = _createStaticVNode("<li class=\"flex items-start gap-2\" data-v-001fb070><span class=\"text-amber-400\" data-v-001fb070>📞</span><span data-v-001fb070>+973 3214 1440</span></li><li class=\"flex items-start gap-2\" data-v-001fb070><span class=\"text-amber-400\" data-v-001fb070>✉️</span><span class=\"break-all\" data-v-001fb070>support@vehitraworld.com</span></li>", 2)),
            _createElementVNode("li", _hoisted_174, [
              _cache[50] || (_cache[50] = _createElementVNode("span", { class: "text-amber-400" }, "📍", -1)),
              _createElementVNode("span", null, _toDisplayString(currentLang.value === 'ar' ? 'البحرين / دعم عالمي' : 'Bahrain / Worldwide Support'), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_175, [
        _createElementVNode("p", null, _toDisplayString(t('footer.rights')), 1)
      ])
    ])
  ], 10, _hoisted_1))
}
}

})